import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GhostwriterEligibilityAndApplicationQueryVariables = Types.Exact<{
  jobKeys: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  applicationsFirst: Types.Scalars['Int']['input'];
}>;


export type GhostwriterEligibilityAndApplicationQuery = { __typename?: 'Query', ghostwriter: { __typename?: 'GhostwriterQueries', jobEligibility: Array<string>, viewer: { __typename?: 'GhostwriterViewer', applications?: { __typename?: 'GhostwriterApplicationsConnection', edges: Array<{ __typename?: 'GhostwriterApplicationEdge', node: { __typename?: 'GhostwriterApplication', id: string, applicationStatus: Types.GhostwriterApplicationStatus, applicationNotes?: string | null, externalApplicationId?: string | null, createdAt: string, updatedAt: string, intervention?: { __typename?: 'GhostwriterInterventionInfo', liveUrl: string, kind: Types.GhostwriterInterventionKind, expiresAt?: string | null } | null, job: { __typename?: 'GhostwriterJob', id: string, parsingStatus: Types.GhostwriterParsingStatus, job: { __typename?: 'Job', key: string, title: string, sourceEmployerName: string, description: { __typename?: 'JobDescription', text: string, html: string }, location: { __typename?: 'JobLocation', formatted: { __typename?: 'FormattedJobLocation', long: string } }, compensation?: { __typename?: 'JobCompensation', formattedText?: string | null } | null } }, formFieldGroups: Array<{ __typename?: 'GhostwriterFormFieldGroup', id: string, groupLabel?: string | null, groupType?: string | null, isCollapsed: boolean, formFields: Array<{ __typename?: 'GhostwriterFormField', id: string, fieldName?: string | null, fieldType: Types.GhostwriterFormFieldType, classification?: string | null, autocompleteType?: Types.GhostwriterAutocompleteType | null, label?: string | null, description?: string | null, placeholder?: string | null, value?: string | null, required: boolean, disabled: boolean, readonly: boolean, confirmsFieldName?: string | null, options?: Array<{ __typename?: 'GhostwriterFieldOption', value: string, label: string }> | null, condition?: { __typename?: 'GhostwriterFieldCondition', fieldName: string, value: string, operator: Types.GhostwriterConditionOperator } | null }>, nestedFormFieldGroup?: { __typename?: 'GhostwriterFormFieldGroup', id: string, groupLabel?: string | null, groupType?: string | null, isCollapsed: boolean, formFields: Array<{ __typename?: 'GhostwriterFormField', id: string, fieldName?: string | null, fieldType: Types.GhostwriterFormFieldType, classification?: string | null, autocompleteType?: Types.GhostwriterAutocompleteType | null, label?: string | null, description?: string | null, placeholder?: string | null, value?: string | null, required: boolean, disabled: boolean, readonly: boolean, confirmsFieldName?: string | null, options?: Array<{ __typename?: 'GhostwriterFieldOption', value: string, label: string }> | null, condition?: { __typename?: 'GhostwriterFieldCondition', fieldName: string, value: string, operator: Types.GhostwriterConditionOperator } | null }> } | null }>, currentResponseSet?: { __typename?: 'GhostwriterResponseSet', id: string, isUserApproved: boolean, createdAt: string, responseGroups: Array<{ __typename?: 'GhostwriterResponseGroup', id: string, name?: string | null, canCreateNewResponseGroup: boolean, displayOrder?: number | null, fieldResponses: Array<{ __typename?: 'GhostwriterFieldResponse', id: string, responseValue?: string | null, selectedOptions: Array<string>, validationStatus: Types.GhostwriterValidationStatus, source: Types.GhostwriterResponseSource, formField: { __typename?: 'GhostwriterFormField', id: string } }> }> } | null } }> } | null } } };


export const GhostwriterEligibilityAndApplicationDocument = gql`
    query GhostwriterEligibilityAndApplication($jobKeys: [String!]!, $applicationsFirst: Int!) {
  ghostwriter {
    jobEligibility(indeedJobKeys: $jobKeys)
    viewer {
      applications(first: $applicationsFirst) {
        edges {
          node {
            id
            applicationStatus
            applicationNotes
            externalApplicationId
            createdAt
            updatedAt
            intervention {
              liveUrl
              kind
              expiresAt
            }
            job {
              id
              parsingStatus
              job {
                key
                title
                description {
                  text
                  html
                }
                location {
                  formatted {
                    long
                  }
                }
                sourceEmployerName
                compensation {
                  formattedText
                }
              }
            }
            formFieldGroups {
              id
              groupLabel
              groupType
              isCollapsed
              formFields {
                id
                fieldName
                fieldType
                classification
                autocompleteType
                label
                description
                placeholder
                value
                required
                disabled
                readonly
                confirmsFieldName
                options {
                  value
                  label
                }
                condition {
                  fieldName
                  value
                  operator
                }
              }
              nestedFormFieldGroup {
                id
                groupLabel
                groupType
                isCollapsed
                formFields {
                  id
                  fieldName
                  fieldType
                  classification
                  autocompleteType
                  label
                  description
                  placeholder
                  value
                  required
                  disabled
                  readonly
                  confirmsFieldName
                  options {
                    value
                    label
                  }
                  condition {
                    fieldName
                    value
                    operator
                  }
                }
              }
            }
            currentResponseSet {
              id
              isUserApproved
              createdAt
              responseGroups {
                id
                name
                canCreateNewResponseGroup
                displayOrder
                fieldResponses {
                  id
                  formField {
                    id
                  }
                  responseValue
                  selectedOptions
                  validationStatus
                  source
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGhostwriterEligibilityAndApplicationQuery__
 *
 * To run a query within a React component, call `useGhostwriterEligibilityAndApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGhostwriterEligibilityAndApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGhostwriterEligibilityAndApplicationQuery({
 *   variables: {
 *      jobKeys: // value for 'jobKeys'
 *      applicationsFirst: // value for 'applicationsFirst'
 *   },
 * });
 */
export function useGhostwriterEligibilityAndApplicationQuery(baseOptions: Apollo.QueryHookOptions<GhostwriterEligibilityAndApplicationQuery, GhostwriterEligibilityAndApplicationQueryVariables> & ({ variables: GhostwriterEligibilityAndApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GhostwriterEligibilityAndApplicationQuery, GhostwriterEligibilityAndApplicationQueryVariables>(GhostwriterEligibilityAndApplicationDocument, options);
      }
export function useGhostwriterEligibilityAndApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GhostwriterEligibilityAndApplicationQuery, GhostwriterEligibilityAndApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GhostwriterEligibilityAndApplicationQuery, GhostwriterEligibilityAndApplicationQueryVariables>(GhostwriterEligibilityAndApplicationDocument, options);
        }
export function useGhostwriterEligibilityAndApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GhostwriterEligibilityAndApplicationQuery, GhostwriterEligibilityAndApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GhostwriterEligibilityAndApplicationQuery, GhostwriterEligibilityAndApplicationQueryVariables>(GhostwriterEligibilityAndApplicationDocument, options);
        }
export type GhostwriterEligibilityAndApplicationQueryHookResult = ReturnType<typeof useGhostwriterEligibilityAndApplicationQuery>;
export type GhostwriterEligibilityAndApplicationLazyQueryHookResult = ReturnType<typeof useGhostwriterEligibilityAndApplicationLazyQuery>;
export type GhostwriterEligibilityAndApplicationSuspenseQueryHookResult = ReturnType<typeof useGhostwriterEligibilityAndApplicationSuspenseQuery>;
export type GhostwriterEligibilityAndApplicationQueryResult = Apollo.QueryResult<GhostwriterEligibilityAndApplicationQuery, GhostwriterEligibilityAndApplicationQueryVariables>;